import angular from 'angular';
 import pdfViewerComponent from './pdf-viewer.component';
// import OrdersService from './orders.service';
// import ordersConfig from './orders.config';
// import SyncOrderModalController from './sync-order-modal/sync-order-modal.controller';
// import orderDetailModule from './order-detail/order-detail';

let pdfViewerModule = angular.module('app.pdfViewer',[])
  .component('pdfViewer', pdfViewerComponent)
//   .controller('SyncOrderModalController', SyncOrderModalController)
//   .service('OrdersService', OrdersService)
//   .config(ordersConfig)
  ;

export default pdfViewerModule;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/shared/components/pdf-viewer/pdf-viewer.js
 **/